import styled from 'styled-components';

export const FeaturesCover = styled.div`
  display: inline-block;
  max-height: 200px;
  width: 100%;
  overflow: hidden;
`;

export const FeatureName = styled.div`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.29px;
  color: #383838;
  padding: 4px 0 12px;
`;

export const FeatureTags = styled.div`
  float: ${(props) => (props.noFloat ? 'unset' : 'left')};
  @media (max-width: 720px) {
    cursor: none;
  }
  @media (min-width: 768px) {
    display: ${(props) => (props.noFloat ? 'none' : 'block')};
  }
  & ul {
    padding: 0 0px 10px;
    margin: -8px 0 0 -5px;
  }
  & ul li {
    border-radius: 4px;
    border: solid 0.5px rgba(0, 0, 0, 0.1);
    margin: 8px 5px 0px;
    display: inline-block;
    padding: 0 5px;
    background-color: #fff;
  }
  & ul li img {
    width: 22px;
    margin-bottom: -7px;
  }
  & ul li span {
    margin-left: 5px;
    font-size: 12px;
    font-weight: 500;
    line-height: 2;
    letter-spacing: 0.24px;
    text-align: center;
    color: #000;
    opacity: 0.8;
  }
`;
